<template>
  <div>
    <div class="page-main__section-header">
      <div class="page-main__section-header-content">
        <h2 class="page-main__section-title">Templates and Design List</h2>
        <p class="page-main__description">Create and edit screen templates and white labels that can be accessed via any project within this client. Note that only one template is allowed per driver.</p>
      </div>
      <div class="page-main__buttons">
        <button class="element-button element-button--primary" :disabled="drivers.length === 0" @click="activateCreationModal">
            Create New Driver Template
        </button>
      </div>
    </div>
    <ClientShadowOverlay
      :createOverlay="isCreationModalActive"
      :client="client"
      :drivers="drivers"
      :hidden-projects="hiddenProjects"
      @close="isCreationModalActive = false"/>
  </div>
</template>
<script>
import ClientShadowOverlay from './ClientShadowOverlay.vue'
export default {
  name: 'ClientTemplateDesignManager',
  components: {
    ClientShadowOverlay
  },
  props: {
    client: {
      type: [String, Array, Object],
      required: true
    },
    drivers: {
      type: Array,
      default () {
        return []
      }
    },
    hiddenProjects: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      isCreationModalActive: false
    }
   },
  methods: {
    activateCreationModal () {
      this.isCreationModalActive = true
    }
  }
}
</script>
